import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { providePopoverConfig } from 'ng-primitives/popover';

export function providePopover(): EnvironmentProviders {
  return makeEnvironmentProviders([
    providePopoverConfig({
      placement: 'bottom',
      offset: 4,
      shift: true,
      flip: true,
      closeOnEscape: true,
      closeOnOutsideClick: false,
      cooldown: 0,
      container: document.body,
      scrollBehavior: 'block',
    }),
  ]);
}
